import classNames from 'classnames';
import { FC } from 'react';

import { popupItemStyles } from '@gem/ui-kit';

import { DeviceIcon } from '../DeviceIcon/DeviceIcon';
import { IDeviceItemProps, useDeviceItemPresenter } from './DeviceItem.presenter';
import styles from './DeviceItem.styles.m.css';

export const DeviceItem: FC<IDeviceItemProps> = (props) => {
  const { className, device, projectName, onClick, deviceSession } = props;
  const presenter = useDeviceItemPresenter({
    device,
    projectName,
    deviceSession,
  });

  const containerClassName = classNames(styles.container, className, {
    [popupItemStyles.interactive]: !!props.onClick,
  });

  return (
    <div
      onClick={onClick}
      className={containerClassName}
    >
      <DeviceIcon
        platform={device.platform}
        className={styles.icon}
      />
      <div className={styles.deviceInfo}>
        <div className={styles.deviceName}>{presenter.device}</div>
        <div className={styles.deviceClient}>{presenter.addFullName}</div>
        <div className={styles.sessionInfo}>{presenter.sessionInfo}</div>
      </div>
    </div>
  );
};
